import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToast } from "./Toast";
import { useDispatch } from "react-redux";
import { RESETPWDDATA } from "../../service/action/actiontype/CommonType/CommonType";
import { onCommonReducerResetPswd } from "../../service/action/actioncreator/CommonAction/Common";
import logoHeader from "../../assests/images/logo-header.png";
import { useForm } from "react-hook-form";
import imgNotification from "../../assests/images/notification.png";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import arrowDropdown from "../../assests/images/arrow-drop-down.png";
import {
  updateAdminPP,
  getByIdUser,
} from "../../service/action/actioncreator/AdminPPAction/AdminPP";
import { sendOtp } from "../../service/action/actioncreator/LoginAction/LoginAction";
import CommonOtpModal from "./commonOtpModal";
import { useLoader } from "../component/LoaderProvider";
import CommonLoader from "../component/commonLoader";
import useValidation from "../utils/validationRules";
import { useTranslation } from "react-i18next";
import StepperModal from "./commonStepper";
import profileICon from "../../assests/images/profile.png";
import exitIcon from "../../assests/images/exit.png";
import lockIcon from "../../assests/images/lock.png";
import { getAsl } from "../../service/action/actioncreator/HospitalAction/Hospital";
import { extractPhoneNumber } from "../utils/commonFunction";
import ConfirmAlert from "./commonAlert";

const Header = () => {
  const [otpSelectionFlag, setOtpSelectionFlag] = useState(false);
  const [otpCodeFlag, setOtpCodeFlag] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [progress, setProgress] = useState(33);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedData, setSelectedData] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorClose, setErrorClose] = useState(false);
  const [countryDialCode, setCountryDialCode] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [previousBtnFlag,setPreviousBtnFlag] =useState(false)
  const [confirmState, setConfirmState] = useState({
    visible: false,
    message: "",
    action: null,
  });
  const [timer,setTimer] =useState(120);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { showToast } = useToast();
  const { showLoader, hideLoader } = useLoader();
  const { validateField } = useValidation();
  const { t } = useTranslation("translation");
  const roleName = localStorage.getItem("roleName");
  const userName = localStorage.getItem("userName");
  const roleId = localStorage.getItem("roleId");

  const aslDropdown = useSelector(
    (state) => state?.hospitalReducer?.aslGetResponse
  );
  const userIdData=localStorage.getItem("userId")
  const otpOptions = [
    { label: "SMS", value: "SMS" },
    { label: "Mail", value: "Mail" },
    { label: "App Twilio Authy", value: "App Twilio Authy" },
  ];
  //  simple ways

  const loading = useSelector((state) => state?.adminPPReducer?.adminPPLoading);
  const profileData = useSelector((state) => state?.adminPPReducer?.adminPPGetIdResponse);
  const userEditResponse= useSelector((state) => state.adminPPReducer.adminPPEditLoading);

  let profileDataID =profileData?.pharmacy?.map((ele)=>(ele?.id))
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
    reset,
    watch,
    trigger,
  } = useForm({ mode: "onChange" });

  watch("FirstName");
  watch("LastName");
  watch("PhoneNumber");
  watch("UserEmail");
  watch("UserPassword");
  watch("UserConfirmPassword");
  watch("asldropdown");
  const {
    register: registerOtp,
    handleSubmit: handleSubmitOtp,
    formState: { errors: errorsOtp },
    getValues: getValuesOtp,
    setValue: setValueOtp,
    control: controlOtp,
    reset: resetOtp,
    watch: watchOtp,
    clearErrors,
  } = useForm({
    mode: "onSubmit",
    defaultValue: {
      selectedOption: "",
      toggleValue: false,
    },
  });

  watchOtp("otp");
  watchOtp("selectedOption");
  

  const stepConfigs = {
    1: [
      {
        title: "Step 1 of 3",
        titleMain: `${t("text_title_basic")}`,
        textFooter: `${t("text_new_administrator_basic_information")}`,
        fields: [
          { type: "heading", content: `${t("text_title_personal_data")}` },
          {
            name: "FirstName",
            type: "text",
            placeholder: `${t("text_name")}*`,
            validation: true,
          },
          {
            name: "LastName",
            type: "text",
            placeholder: `${t("text_surname")}*`,
            validation: true,
          },
         !( roleId == 7 || roleId == 1 || roleId ==2 ||  roleId == 8 ||  roleId == 9)&& {
            name: "asldropdown",
            type: "dropdown",
            placeholder: `${t("text_placeholder_asl")}*`,
            validation: true,
          },
          {
            name: "FiscalCode",
            type: "text",
            placeholder: `${t("text_taxId_code")}`,
            validation: true,
          },
          { type: "heading", content: `${t("text_contact")}` },
          {
            name: "PhoneNumber",
            type: "phoneNumber",
            placeholder: `${t("text_telephone")}*`,
            validation: true,
          },
          {
            type: "button",
            label: `${t("text_button_confirms")}`,
            disabled:
              getValues("FirstName")?.length == 0 ||
              getValues("LastName")?.length == 0 ||
              getValues("PhoneNumber")?.length == 0
                ? true
                : false || getValues("asldropdown")?.length == 0,
          },
        ],
      },
      {
        title: "Step 2 of 3",
        titleMain: `${t("text_title_accounts_passwords")}`,
        textFooter: `${t("text_enter_account_passowrd_message")}`,
        fields: [
          { type: "heading", content: `${t("text_title_login")}` },
          {
            name: "UserEmail",
            type: "textStep2",
            placeholder: `${t("Email")}*`,
            validation: true,
          },
          { type: "buttonRowEmail" },
        ],
      },
      {
        title: "Step 3 of 3",
        titleMain: `${t("text_title_summary")}`,
        textFooter: "Controlla l'esattezza dei dati inseriti per procedere",
        fields: [
          { type: "heading", content: `${t("text_new_administrator_data")}` },
          { type: "summary", content: "" },
          { type: "buttonsRow1",disabled:userEditResponse },

        ],
      },
    ],
  };
  const roleBasedSteps = stepConfigs[1];

  const start = (
    <div className="d-flex align-items-center ms-2">
      <img
        alt="logo"
        src={logoHeader}
        height="100%"
        width="100%"
        className="me-3"
      />
    </div>
  );
  const end = (
    <div className="d-flex align-items-center me-4">
      <img
        alt="notification"
        src={imgNotification}
        className="me-3"
        style={{ cursor: "pointer" }}
      />
      <div
        className="border-end"
        style={{ height: "2rem", borderWidth: "5px", color: "black" }}
      ></div>
      {/* future use */}
      {/* <img
      alt="profile"
      src={Avatar}
      height="40"
      className="ms-3"
      style={{ borderRadius: '50%', cursor: 'pointer' }}
    /> */}
      <div className="d-flex flex-column justify-content-between">
        <div className="ms-3 mb-0 fs-4  text-align-right">{userName}</div>
        <div className="ms-5 mb-0 font-size-sm text-align-right">
          {"Ruolo: "}
          {`${t(roleName)}`}
        </div>
      </div>

      <img
        alt="dropdown"
        src={arrowDropdown}
        className="ms-3"
        style={{ cursor: "pointer" }}
        onClick={() => setDropdownVisible(!dropdownVisible)}
      />
    </div>
  );

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("sideMenu");
    localStorage.removeItem("userId");
    localStorage.removeItem("roleId");
    localStorage.removeItem("authenticationType");
    localStorage.removeItem("oldpassword");
    localStorage.removeItem("password");
    localStorage.setItem("isSuccess", false);
    if (
      localStorage?.getItem("authData") === null ||
      Object?.keys(localStorage?.getItem("authData"))?.length === 0
    ) {
      setDropdownVisible(false);
      showToast("success", "Successo", "Disconnessione riuscita!");
      navigate("/login");
    }
  };
  const handleClickOutside = (event) => {
    if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
      setDropdownVisible(false);
    }
  };
  useEffect(() => {
    document?.addEventListener("mousedown", handleClickOutside);
    return () => {
      document?.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let headers = {
      AccessIdentifier: "Validate",
    };
    let headersAsl = {
      isAll: true,
    };
    let addASLObject = { headersAsl, showLoader, hideLoader, showToast, t };

    if (isModalOpen === true) {
      dispatch(getByIdUser(headers, showLoader, hideLoader));
      dispatch(getAsl(addASLObject));
    }
  }, [isModalOpen]);

  const handleItemClick = () => {
    setDropdownVisible(false);
    setProgress(33);
    setCurrentStep(1);
    
    setIsModalOpen(true);
    let headers = {
      AccessIdentifier: "Validate",
    };
    let headersupdate = {
      isAll: true,
    };
    dispatch(getByIdUser(headers, showLoader, hideLoader));
    let addASLObject = { headersupdate, showLoader, hideLoader, showToast, t };
    dispatch(getAsl(addASLObject));
  };
  const aslOptions = aslDropdown?.result?.map((option) => ({
    label: `${option?.regionName}${","} ${option?.municipality}${","} ${
      option?.companyName
    }`,
    value: option?.id,
  }));

  const handleCountryChange = (data) => {
    setCountryDialCode(data?.dialCode);
    setCountryCode(data?.countryCode);
  };

  const handleModalSubmitOtp = () => {
    let id = localStorage.getItem("userId");
    let navigateFlag = false;
    let payload = {
      userId: parseInt(id),
      authenticationFor: "update user",
      authenticationType: getValuesOtp("selectedOption")=="Mail" ? 1 : getValuesOtp("selectedOption")=="SMS" ? 2 : 1,
    };
    let pharamcyId = [];
    pharamcyId?.push(getValues("hospitalPharamacyName"));

    let hospitalId = [];
    hospitalId?.push(getValues("hospitalAdministratorName"));

    var userId = localStorage.getItem("userId");
    let payloadValue = {
      userId: parseInt(userId),
      firstName: getValues("FirstName"),
      lastName: getValues("LastName"),
      fiscalCode: getValues("FiscalCode"),
      email: getValues("UserEmail"),
      passwordHash: getValues("UserPassword"),
      roleId: parseInt(localStorage.getItem("roleId")),
      authenticationType: getValuesOtp("selectedOption")=="Mail" ? 1 : getValuesOtp("selectedOption")=="SMS" ? 2 : 1 ,
      phoneNumber:`${extractPhoneNumber(countryDialCode,getValues("PhoneNumber"))}`,
      countryId: parseInt(countryDialCode),
      countryCode: countryCode?.toUpperCase(),
      fkAsl: getValues("asldropdown"),
    };

    let payloadUpdate = {
      ...profileData,
      ...payloadValue, 
      pharmacyIds:profileData?.pharmacy?.map(md=>md?.id),
      hospitalIds:profileData?.hospital?.map(md=>md?.id)
    };
    var headers = {
      UserId: parseInt(userId),
      AuthenticationType: getValuesOtp("selectedOption")==="Mail" ? 1 : getValuesOtp("selectedOption")==="SMS" ? 2 : 1 ,
      AuthenticationFor: "update User",
      OtpCode: String(getValuesOtp("otp")),
      Accessidentifier: "verify",
      RoleId: parseInt(localStorage.getItem("roleId")),
    };

    if (otpSelectionFlag && !otpCodeFlag  && !previousBtnFlag && getValuesOtp("selectedOption")?.length > 0 ) {
      dispatch(
        sendOtp(
          payload,
          navigate,
          showLoader,
          hideLoader,
          navigateFlag,
          setOtpSelectionFlag,
          setOtpCodeFlag,
          setTimer
        )
      );
    } else if (otpSelectionFlag  && !otpCodeFlag  && getValuesOtp("selectedOption")?.length === 0 && !errorClose) {
      showToast("warn", "Attenzione", "Seleziona almeno un'opzione");
    }
    if (!otpSelectionFlag  && otpCodeFlag  &&getValuesOtp("otp")?.length > 0) {
      
      let id = selectedData?.id;
      let updateObject = {
        id,
        payloadUpdate,
        headers,
        showLoader,
        hideLoader,
        showToast,
        t,
      };
      dispatch(updateAdminPP(updateObject, setOtpCodeFlag));
    }
  };

  const handleModalCloseOtp = () => {
    setOtpSelectionFlag(false);
    setOtpCodeFlag(false);
    setIsModalOpen(false);
    setProgress(33);
    setCurrentStep(1);
    handleResetOtp();
    resetOtp();
    setPreviousBtnFlag(false)
    
  };
  const handleModalCancelOtp = () => {
    if (otpCodeFlag) {
      setOtpSelectionFlag(true);
      setOtpCodeFlag(false);
      resetOtp();
      setErrorClose(true);
    }
    if (otpSelectionFlag) {
      setOtpSelectionFlag(false);
      setIsModalOpen(true);
      resetOtp();
      setErrorClose(true);
    }
  };

  const handleResetOtp = () => {
    resetOtp({
      selectedOption: "",
      otp: "",
    });
  };

  const progressMap = {
    1: 33,
    2: 66,
    3: 100,
  };
  useEffect(() => {
    setProgress(progressMap[currentStep]);
  }, [currentStep]);


  const handleSubmitStep = async () => {
    handleResetOtp();
    let id = localStorage.getItem("userId");
    let pharamcyId = [];
    pharamcyId?.push(getValues("hospitalPharamacyName"));

    let hospitalId = [];
    hospitalId?.push(getValues("hospitalAdministratorName"));

    var userId = localStorage.getItem("userId");
    let payloadValue = {
      firstName: getValues("FirstName"),
      lastName: getValues("LastName"),
      fiscalCode: getValues("FiscalCode"),
      email: getValues("UserEmail"),
      passwordHash: getValues("UserPassword"),
      roleId: parseInt(localStorage.getItem("roleId")),
      authenticationType: getValuesOtp("selectedOption")=="Mail" ? 1 : getValuesOtp("selectedOption")=="SMS" ? 2 : 1 ,
      phoneNumber:`${extractPhoneNumber(countryDialCode,getValues("PhoneNumber"))}`,
      countryId: parseInt(countryDialCode),
      countryCode: countryCode?.toUpperCase(),
      fkAsl: getValues("asldropdown"),
      pharmacyIds:profileDataID,
      accessidentifier: "Validate"

    };
    let payloadUpdate = {
      ...profileData,
      ...payloadValue, 
    
      pharmacyIds:profileData?.pharmacy?.map(md=>md?.id),
      hospitalIds:profileData?.hospital?.map(md=>md?.id)
    };

    var headers = {
      UserId: parseInt(userId),
      AuthenticationType: getValuesOtp("selectedOption")==="Mail" ? 1 : getValuesOtp("selectedOption")==="SMS" ? 2 : 1 ,
      AuthenticationFor: "update User",
      Accessidentifier: "validate",
      RoleId: parseInt(localStorage.getItem("roleId")),
    };
    let updateHeader=true
    let updateObject = {id,payloadUpdate,headers,showLoader,hideLoader,showToast,t,setOtpSelectionFlag,updateHeader};
    dispatch(updateAdminPP(updateObject, setOtpCodeFlag,setIsModalOpen));

  };

  const handleCloseSubmission = () => {
    setIsModalOpen(false);
    setOtpCodeFlag(false);
    setOtpSelectionFlag(false);
    setProgress(33);
    setCurrentStep(1);
    handleResetOtp();
    setIsSuccess(false);
  };
  const ResetFnClose = () => {
    setIsModalOpen(false);
    setOtpSelectionFlag(false);
    setIsSuccess(false);
    reset();
    handleResetOtp();
    reset();
    resetOtp();
  }

  const handleModalClose = () => {
    if (getValues("FirstName")?.length === 0 &&getValues("LastName")?.length === 0 && getValues("PhoneNumber")?.length === 0 && getValues("asldropdown")?.length===0) {
      ResetFnClose();
    } else {
      showConfirm("Se chiudi il modale, perderai i dati.", () => {
        ResetFnClose();
      });
    }
  };
  const handleChangePassword = () => {
    dispatch(onCommonReducerResetPswd(true, RESETPWDDATA));
    navigate("/resetPassword");
  };

  const handleModalSubmit = () => {
    // console.log("check11");
  };

  useEffect(() => {
    setSelectedData(profileData);
    setValue("FirstName", selectedData?.firstName);
    setValue("LastName", selectedData?.lastName);
    setValue("FiscalCode", selectedData?.fiscalCode);
    setValue(
      "PhoneNumber", selectedData?.phoneNumber
    );
    setCountryCode(selectedData?.countryCode);
    setCountryDialCode(selectedData?.phoneCode);
    setValue("UserEmail", selectedData?.email);
    setValue("asldropdown",aslOptions?.find((obj) => obj?.value === selectedData?.aslId)?.value);
  }, [profileData, selectedData]);

  const onBack=()=>{
    if(otpSelectionFlag){
      setOtpSelectionFlag(false)
      setIsModalOpen(true)
      
    }else if(otpCodeFlag){
      setOtpCodeFlag(false)
      setOtpSelectionFlag(true)
      setPreviousBtnFlag(true)
    }
  }
  const showConfirm = (message, action) => {
    setConfirmState({
      visible: true,
      message,
      action,
    });
  };
  const hideConfirm = () => {
    setConfirmState({ visible: false, message: "", action: null });
  };
  const onConfirm = () => {
    if (confirmState?.action) {
      confirmState?.action();
    }
    hideConfirm();
  };

  return (
    <>
      <div className="header-container-align d-flex align-items-center justify-content-between px-3">
        <div className="header-start">{start}</div>
        {/* future use */}
        {/* <div className="header-center flex-grow-1 mx-3">{searchBar}</div>   */}
        <div className="header-end">{end}</div>
      </div>

      {dropdownVisible && (
        <div className="header-dropdown-container" ref={dropdownRef}>
          <div className="p-dropdown p-component mt-4">
            <ul className="p-dropdown-list">
              <li className="p-dropdown-item" onClick={handleItemClick}>
                <img src={profileICon} className="pi" height={15} width={15} />
                <span className="ms-2">Profilo</span>
              </li>
              <li className="p-dropdown-item" onClick={handleChangePassword}>
                <img src={lockIcon} className="pi" height={15} width={15} />
                <span className="ms-2">Cambio Password</span>
              </li>
              <li className="p-dropdown-item" onClick={logOut}>
                <img src={exitIcon} className="pi" height={15} width={15} />
                <span className="ms-2">Disconnettersi</span>
              </li>
              <li style={{ display: "none" }} className="p-dropdown-item">
                <img src={exitIcon} className="pi" height={15} width={15} />
                <span className="ms-2">V 0.1.4</span>
              </li>
            </ul>
          </div>
        </div>
      )}
      {(otpSelectionFlag || otpCodeFlag) && (
        <CommonOtpModal
        timer={timer}
        setTimer={setTimer}
        authenticationdata='update user'
          isOpen={otpSelectionFlag || otpCodeFlag}
          title={
            otpSelectionFlag ? "Modalità di selezione OTP" : "Verifica OTP"
          }
          onClose={() => handleModalCloseOtp()}
          onSubmit={handleSubmitOtp(handleModalSubmitOtp)}
          onReset={() => handleModalCancelOtp()}
          control={controlOtp}
          register={registerOtp}
          watch={watchOtp}
          errors={errorsOtp}
          otpOptions={otpOptions}
          validationFn={validateField}
          verification={otpSelectionFlag ? true : false}
          getValue={getValuesOtp}
          setValue={setValueOtp}
          clearErrors={clearErrors}
          defaultValue={true}
          onBack={onBack}
          userId={parseInt(userIdData)}
        />
      )}
      {isModalOpen && aslDropdown?.result?.length > 0 && (
        <StepperModal
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          currentStep={currentStep}
          progress={progress}
          getValues={getValues}
          isSuccess={isSuccess}
          control={control}
          errors={errors}
          register={register}
          validateField={validateField}
          handleCloseSubmission={handleCloseSubmission}
          watch={watch}
          roleBasedSteps={roleBasedSteps}
          onSubmit={handleSubmit(handleModalSubmit)}
          onCountryChange={handleCountryChange}
          handleSubmitStep={handleSubmitStep}
          trigger={trigger}
          setProgress={setProgress}
          setCurrentStep={setCurrentStep}
          aslDropdown={
            aslDropdown?.result?.length > 0 ? aslDropdown?.result : []
          }
          // mainTitle={t("text_qc_administrators")}
          mainTitle={`${t(roleName)}`}
          size={"lg"}
          countryDialCode={countryDialCode}
          profileUpdatePage={true}
          progressHide={false}
        />
      )}
       <ConfirmAlert
        visible={confirmState?.visible}
        onHide={hideConfirm}
        message={confirmState?.message}
        onConfirm={onConfirm}
      />
      <CommonLoader loading={loading} />
    </>
  );
};
export default Header;
